import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import store from 'dashboard/store';

let initialized = false;

const getColorScheme = () =>
  LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';

export const loadWhatsGptWidget = ({ locale }) => {
  if (initialized) return;

  const websiteToken = window.globalConfig?.CHATWOOT_INBOX_TOKEN;
  if (!websiteToken) return;

  initialized = true;

  const baseUrl = window.chatwootConfig?.hostURL || '';

  window.whatsgptSettings = {
    hideMessageBubble: false,
    position: store.getters['accounts/isRTL'] ? 'left' : 'right',
    locale,
    darkMode: getColorScheme(),
  };

  const run = () => window.whatsgptSDK?.run({ websiteToken, baseUrl });

  if (window.whatsgptSDK) {
    run();
  } else {
    const script = document.createElement('script');
    script.src = `${baseUrl}/packs/js/wgpt/sdk.js`;
    script.defer = true;
    script.async = true;
    script.onload = run;
    document.body.appendChild(script);
  }
};
